export const LS_SOURCE = 'goto-admin'
export const LS_DEFAULT_COMPONENT = 'unified-admin'

export enum RESTRICTED_LOGGER_KEYS {
  LS_COMPONENT = 'ls_component',
  LS_SUB_COMPONENT = 'goto_admin_sub_component',
  LS_USER_KEY = 'goto_admin_user_key',
  LS_ACCOUNT_KEY = 'goto_admin_account_key',
  LS_PBX_ID = 'goto_admin_pbx_id',
  LS_USER_AGENT = 'ls_user_agent',
  LS_LANGUAGE = 'ls_language',
}
